import { formatUnreadCount } from "@/Components/Sidebar/formatUnreadCount";
import { useClientFeature } from "@/hooks/useClientFeature";
import { useUnreadNotificationsCount } from "@/pages/Dashboard/Notifications/hooks/useNotifications";
import { useSidebarStore } from "@/stores/useSidebarStore";
import { cn } from "@/utils";
import { Button } from "@heroui-v3/react";
import { t } from "@lingui/core/macro";
import { ArrowLeft, TextAlignStart } from "lucide-react";

type MobileSidebarToggleProps = {
  onMobileBackButtonClick?: () => void;
  withoutRightMargin?: boolean;
};

export const MobileSidebarToggle = ({
  onMobileBackButtonClick,
  withoutRightMargin,
}: MobileSidebarToggleProps) => {
  const toggleSidebar = useSidebarStore((state) => state.toggle);
  const { isFeatureEnabled } = useClientFeature();
  const isInAppNotificationsEnabled = isFeatureEnabled("inAppNotifications");

  const unreadCount = useUnreadNotificationsCount({
    enabled: isInAppNotificationsEnabled,
  });

  const showUnreadBadge = !onMobileBackButtonClick && unreadCount > 0;

  return (
    <Button
      type="button"
      className={cn(
        "relative mr-[30px] flex h-10 w-10 overflow-visible rounded-full md:hidden",
        {
          "mr-0": withoutRightMargin,
        },
      )}
      isIconOnly
      variant={onMobileBackButtonClick ? "tertiary" : "primary"}
      aria-label={
        onMobileBackButtonClick ? t`Nazaj` : t`Odpri/zapri stranski meni`
      }
      onPress={() => {
        if (onMobileBackButtonClick) onMobileBackButtonClick();
        else toggleSidebar(true);
      }}
    >
      {onMobileBackButtonClick ? (
        <ArrowLeft size={20} className="text-black" />
      ) : (
        <TextAlignStart size={20} />
      )}

      {showUnreadBadge && (
        <span className="bg-danger absolute top-0 -right-1 flex min-h-5 min-w-5 items-center justify-center rounded-full px-1 text-[11px] leading-none text-white">
          {formatUnreadCount(unreadCount)}
        </span>
      )}
    </Button>
  );
};
